<h1 mat-dialog-title>{{'ADD_CALENDER.EVENT_DETAILS' | translate}}</h1>
<div mat-dialog-content>
  <mat-form-field>
    <input matInput [(ngModel)]="data.eventDescription" placeholder="{{'ADD_CALENDER.EVENT_DESCRIPTION' | translate}}">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">{{'ADD_CALENDER.CANCEL' | translate}}</button>
  <button mat-button color="prmary" [mat-dialog-close]="data.eventDescription" cdkFocusInitial>{{'ADD_CALENDER.OK' | translate}}</button>
</div>